import { render, staticRenderFns } from "./PurchaseNgApplication.vue?vue&type=template&id=4cc68847&"
import script from "./PurchaseNgApplication.vue?vue&type=script&lang=js&"
export * from "./PurchaseNgApplication.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports